import React, { Fragment } from "react";
import PropTypes from "prop-types";
import CarouselComponent from "../carousel";
import "./styles.css";

const GaleriaCarouselComponent = (props) => {
  return (
    <Fragment>
      <div className="galeria-contenedor">
        <CarouselComponent componente={props.componente}></CarouselComponent>
      </div>
    </Fragment>
  );
};

GaleriaCarouselComponent.propTypes = {
  componente: PropTypes.string,
};

export default GaleriaCarouselComponent;
